import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface LowStockItem {
  id: string;
  name: string;
  quantity: number;
  threshold: number;
  image?: string;
  lastUpdated: Date;
}

@Injectable({
  providedIn: 'root'
})
export class InventoryService {
  private apiUrl = `${environment.base_url}`;

  constructor(private http: HttpClient) { }

  getLowStockItems(): Observable<LowStockItem[]> {
    return this.http.get<LowStockItem[]>(`${this.apiUrl}lapsingProduct`);
  }

  getLowStockItemsPage(page: number, limit: number): Observable<{
    items: LowStockItem[];
    total: number;
  }> {
    return this.http.get<{
      items: LowStockItem[];
      total: number;
    }>(`${this.apiUrl}/lapsingProduct?page=${page}&limit=${limit}`);
  }

  getLapsingProducts(vendorId?: string): Observable<any> {
    const url = vendorId
      ? `${this.apiUrl}lapsingProduct?vendorId=${vendorId}`
      : `${this.apiUrl}lapsingProduct`;
    return this.http.get(url);
  }

  getAllVendors(): Observable<any> {
    return this.http.get(`${this.apiUrl}allVendors`);
  }
} 